var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMInfo = function SvgMInfo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 8.75,
    fill: "#EEC764"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26562 6.54102H8.54688L10.4893 12.0254L12.4316 6.54102H13.7129L11.1084 14H10.2168L7.26562 6.54102ZM6.62988 6.54102H7.9043L8.14453 11.8867V14H6.62988V6.54102ZM13.1143 6.54102H14.3965V14H12.9521V11.8867L13.1143 6.54102Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMInfo);
export { ForwardRef as ReactComponent };